import React, { useEffect, useState } from "react";
import "../styles/Contact.css";
import Navbar from "../components/Navbar";
import scale from "../assets/images/scale.webp";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import HomeContactSection from "../components/HomeContactSection";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    time: new Date().toLocaleString(),
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_TejCodex",
        "template_9w26kov",
        templateParams,
        "-1wDk-Z48uDBTDyvr"
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        () => {
          setLoading(false);
          setError(true);
        }
      );
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(false);
      }, 10000); // 10 seconds = 10000 ms
    }
    return () => clearTimeout(timer);
  }, [success, error]);


  return (
    <div className="Ccontact">
      <Navbar />
      <div className="Cmsg-trapezium">
        <div className="Cmsg-trapezium-black1"></div>
        <div className="Cmsg-trapezium-white1">
          <span className="Cmsg-icn"></span>
        </div>
      </div>
      <div className="Cmsg-trapezium-black2"></div>
      <div className="Cmsg-trapezium-white2">
        <span className="Cmsg-icn"></span>
      </div>
      <h1 className="Cheading">Contact Us...</h1>

      <section className="Ccontact-section">
        <p className="Ccontact-subtext">
          📩 We’d love to hear from you! Whether it’s a suggestion, error
          correction, or feedback to improve <strong>TejCodex</strong>, your
          voice matters and helps us grow. 🤝
        </p>
        <p className="Ccontact-subtext">
          💡 Every idea, no matter how small, can make a big difference.
          Together, let’s upgrade this platform so that it makes learning law
          easier, clearer, and more accessible for everyone. ⚖️✨
        </p>
        <p className="Ccontact-subtext">
          🚀 Join us in shaping <strong>TejCodex</strong> into a space that
          supports every law student’s journey — because knowledge grows best
          when shared. 🌱📚
        </p>
      </section>

      <HomeContactSection
        scale={scale}
        formData={formData}
        loading={loading}
        success={success}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      <footer className="Cfooter-section">
        <div className="Cfooter-top">
          <img src={scale} alt="Scale" className="Cfooter-logo" />
          <span className="Cfooter-title">TejCodex.com</span>
          <span className="Cfooter-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="Cfooter-links">
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> | <a href="/aibe-preparation"> AIBE</a> | <a href="/about"> About Us</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
}

export default Contact;
